import styled from 'styled-components'

export default styled.div`
  position: relative;

  .save-overlay-toggle {
    position: absolute;
    z-index: 10;
    right: 0px;
  }
  .save-overlay-delete-button {
    position: absolute;
    z-index: 5;
    right: 0px;
    bottom: 0px;
  }

  .save-overlay-container {
    position: absolute;
    z-index: 10;
    height: 100%;
    width: 100%;
    overflow: hidden;

    backdrop-filter: blur(10px);
    background-color: rgba(255, 255, 255, 0.5);
    box-shadow: ${({ theme }) => theme.main.shadowHover};
    border-radius: ${({ theme }) => theme.main.borderRadius}px;
    padding: ${({ theme }) => theme.spacing.spacing24}px 0px;

    transition: height ${({ theme }) => theme.main.defaultAnimation},
      width ${({ theme }) => theme.main.defaultAnimation},
      padding ${({ theme }) => theme.main.defaultAnimation};

    .save-overlay-container-inner {
      padding: 0px ${({ theme }) => theme.spacing.spacing24}px;
    }

    &.hidden {
      height: 0%;
      padding: 0px;
      overflow: hidden;
    }

    .save-overlay-content {
      user-select: none;
    }
  }
`
